const rpServiceTypes = {
  Unset: 0,
  Evaluacion: 1,
  Terapia: 2,
  CompraEquipoAsistivo: 3,
  AsistenteServiciosEnfermera: 4,
  Transportacion: 5,
  BarrerasArquitectonicas: 6,
  ServicioNoDisponible: 7,
};

export default rpServiceTypes;
